module.exports = __webpack_public_path__ + "static/media/annoying-sex-map.c812cb12.png";